module.exports = __webpack_public_path__ + "static/flags/AR-9c5a65483f6b46685b7ccfc8af942e5e.gif";